// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"e5c982f0","675":"3271903b"}[chunkId] + ".chunk.js";
};